import { Injectable } from '@angular/core';
import {
  AppTokenService,
  LogoutService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  getQueryParameter,
  trackErrorInTrackJs
} from '../adapters/utils/utils.adapter';
import { QUERY_PARAMS } from '../constants/common.constants';
import { BOOK_WIDGET_ERROR_CODES } from '../constants/error-codes.constants';

@Injectable({ providedIn: 'root' })
export class SitewideUserAuthServices {
  private cachedToken: string | null = null;

  constructor(
    private appTokenService: AppTokenService,
    private logoutService: LogoutService
  ) {}

  fetchAccessToken = async (): Promise<string | null> => {
    if (this.cachedToken) return this.cachedToken;
    try {
      const { access_token = '', expires_in = 0 } =
        await this.fetchAccessTokenDetails();
      if (!access_token) {
        trackErrorInTrackJs(
          BOOK_WIDGET_ERROR_CODES.NO_AUTH_TOKEN_BUT_USER_LOGGED_IN,
          getQueryParameter(QUERY_PARAMS.CACHE_KEY_SUFFIX)
        );
        this.logoutService.logOut(window.location.href, true);
      }
      this.cachedToken = access_token;
      this.setTokenExpiry(expires_in);
      return access_token;
    } catch (error) {
      trackErrorInTrackJs(
        BOOK_WIDGET_ERROR_CODES.NO_AUTH_TOKEN_BUT_USER_LOGGED_IN,
        getQueryParameter(QUERY_PARAMS.CACHE_KEY_SUFFIX)
      );
      this.logoutService.logOut(window.location.href, true);
      return null;
    }
  };

  private async fetchAccessTokenDetails() {
    return await this.appTokenService
      .getAppTokenWithParams('', '', true)
      .toPromise();
  }

  private setTokenExpiry(expiryTime: number) {
    setTimeout(() => {
      if (this.cachedToken) {
        trackErrorInTrackJs(
          BOOK_WIDGET_ERROR_CODES.MAKING_TOKEN_NULL_AFTER_30_MINS,
          getQueryParameter(QUERY_PARAMS.CACHE_KEY_SUFFIX)
        );
      }
      this.cachedToken = null;
    }, expiryTime * 1000);
  }
}
